import type { ReactNode } from 'react'

interface ListLayoutProps {
	title?: ReactNode
	headEndSlot?: ReactNode
	summarySlot?: ReactNode
	controlsSlot?: ReactNode
	listSlot: ReactNode
}

/**
 * Index-page content: a page title with optional actions, an optional toolbar
 * (filters/search) on the app's grey filter bar below it, and a height-constrained list region that fills
 * the rest. Top-level pages render their own `title` (the shell breadcrumb is
 * reserved for deeper pages). The card frame is provided by the app shell.
 */
function ListLayout({
	title,
	headEndSlot,
	summarySlot,
	controlsSlot,
	listSlot
}: ListLayoutProps) {
	return (
		<div className='flex h-full min-h-0 flex-col gap-3 p-4 md:p-6'>
			{(title || headEndSlot) && (
				<div className='flex flex-wrap items-center gap-3'>
					{title && (
						<h1 className='font-semibold text-2xl tracking-tight'>
							{title}
						</h1>
					)}
					{headEndSlot ? (
						<div className='md:ml-auto'>{headEndSlot}</div>
					) : null}
				</div>
			)}
			{summarySlot && <div className='shrink-0'>{summarySlot}</div>}
			{controlsSlot && (
				<div className='flex flex-col items-stretch gap-1.5 rounded-lg bg-muted/70 p-1.5 md:flex-row md:items-center [&_[data-slot=select-trigger]]:bg-background'>
					{controlsSlot}
				</div>
			)}
			<section className='flex min-h-0 flex-1 flex-col overflow-hidden'>
				{listSlot}
			</section>
		</div>
	)
}

export { ListLayout }
